import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { MwLoadOptionsService } from './../services/utils/load-options.service';
import { MwLoadOptions } from './../models/load-options.model';
import { MwPayloadModel } from './../models/payload.model';
import { CustomerApiModel } from 'app/models/customer-api.model';

@Injectable()
export class MwCustomersApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  getCustomers(
    requestModel?: MwLoadOptions
  ): Observable<MwPayloadModel<CustomerApiModel[]>> {
    const query = requestModel
      ? this.loadOptionsService.buildQuery(requestModel)
      : '';

    return this.http.authGet<MwPayloadModel<CustomerApiModel[]>>(
      `/integration/v1/Companies/{companyId}/Customers` +
        (query.length > 0 ? '?' + query : query)
    );
  }

  createCustomer(customer: CustomerApiModel): Observable<number> {
    return this.http.authPost<number>(
      `/integration/v1/Companies/{companyId}/Customers`,
      {
        body: customer,
      }
    );
  }

  updateCustomer(customer: CustomerApiModel): Observable<CustomerApiModel> {
    return this.http.authPut<CustomerApiModel>(
      `/integration/v1/Companies/{companyId}/Customers`,
      {
        body: customer,
      }
    );
  }

  deleteCustomer(customer: CustomerApiModel): Observable<any> {
    return this.http.authDelete(
      `/integration/v1/Companies/{companyId}/Customers`,
      {
        body: customer,
      }
    );
  }
}
